import ITransactionInterface from 'model/Transaction/ITransactionInterface';

export const sortTransactionsByDate = (transactions: ITransactionInterface[]) => {
    return transactions.sort((a, b) => b.transactionDate?.getTime() - a.transactionDate?.getTime())
}